"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalMentionMarkerId = void 0;
var react_1 = __importDefault(require("react"));
var react_mentions_1 = require("react-mentions");
var validator_1 = __importDefault(require("validator"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var MentionUtilities_1 = require("../MentionUtilities");
var AddCommentSuggestion_1 = __importDefault(require("./AddCommentSuggestion"));
var BlankOrInvite_1 = require("Common/Expansion/BlankOrInvite/BlankOrInvite");
var MentionRegex_1 = require("../MentionUtilities/MentionRegex");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
exports.ExternalMentionMarkerId = "EXTERNALMENTION";
var AddCommentInput = (function (_super) {
    __extends(AddCommentInput, _super);
    function AddCommentInput() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.errorMessage = "";
        _this.renderSuggestion = function (errorMessage) {
            return function (suggestion) {
                var pagePermissionsStore = _this.props.pagePermissionsStore;
                if (suggestion.id === exports.ExternalMentionMarkerId) {
                    return (react_1.default.createElement("div", { className: "suggestion-wrapper suggestion-wrapper--empty", onClick: function (evt) { return evt.stopPropagation(); }, onKeyDown: function (evt) {
                            if (evt.key === "Enter") {
                                evt.stopPropagation();
                            }
                        } },
                        react_1.default.createElement(BlankOrInvite_1.BlankOrInvite, { onClickInvite: _this.onClickInvite(suggestion), showInvite: validator_1.default.isEmail(suggestion.display), errorMessage: errorMessage })));
                }
                else {
                    return (react_1.default.createElement("div", { className: "suggestion-wrapper" },
                        react_1.default.createElement(AddCommentSuggestion_1.default, { suggestion: suggestion, pagePermissionsStore: pagePermissionsStore })));
                }
            };
        };
        _this.onClickInvite = function (suggestion) {
            return function (event) { return __awaiter(_this, void 0, void 0, function () {
                var _a, onInviteUser, inputRef, userAccepted, elem_1;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this.props, onInviteUser = _a.onInviteUser, inputRef = _a.inputRef;
                            event.stopPropagation();
                            return [4, onInviteUser(suggestion.display)];
                        case 1:
                            userAccepted = _b.sent();
                            if (userAccepted === true) {
                                elem_1 = inputRef.current;
                                if (!elem_1) {
                                    throw new Error("Something bad happened where the input reference didn't exist before clicking invite");
                                }
                                elem_1.focus();
                                setTimeout(function () {
                                    var selectionPoint = elem_1.selectionStart;
                                    elem_1.setSelectionRange(selectionPoint - 1, selectionPoint - 1);
                                    elem_1.setSelectionRange(selectionPoint, selectionPoint);
                                    setTimeout(function () {
                                        _this.simulateEnterKeypress(elem_1);
                                    });
                                }, 170);
                            }
                            else if (userAccepted === false) {
                                throw Error();
                            }
                            else {
                                this.setErrorMessage(userAccepted);
                                throw Error();
                            }
                            return [2];
                    }
                });
            }); };
        };
        _this.onChangeMapper = function (_event, newValue, newPlaintextValue, mentions) {
            if (mentions.find(function (mention) { return mention.id === exports.ExternalMentionMarkerId; })) {
                return;
            }
            _this.props.onChange(newValue, mentions, newPlaintextValue);
        };
        _this.setErrorMessage = function (message) {
            _this.errorMessage = message;
            setTimeout(function () {
                _this.setErrorMessage("");
            }, kaleidoscope_1.ErrorTooltipTimeout);
        };
        _this.simulateEnterKeypress = function (elem) {
            var event = new KeyboardEvent("keydown", {
                altKey: false,
                bubbles: true,
                cancelBubble: false,
                cancelable: true,
                charCode: 0,
                code: "Enter",
                composed: true,
                ctrlKey: false,
                currentTarget: null,
                key: "Enter",
                keyCode: 13,
                isTrusted: true,
            });
            elem.dispatchEvent(event);
        };
        return _this;
    }
    AddCommentInput.prototype.render = function () {
        var _a = this.props, value = _a.value, placeholder = _a.placeholder, inputRef = _a.inputRef, onBlur = _a.onBlur, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, pagePermissionsStore = _a.pagePermissionsStore, onAddMentionComplete = _a.onAddMentionComplete;
        var markupFormatWithTokens = (0, MentionUtilities_1.getReactMentionsFormat)("__display__", "__id__");
        return (react_1.default.createElement(react_mentions_1.MentionsInput, { className: "add-comment-input", placeholder: placeholder || "Add a comment...", value: value, inputRef: inputRef, onBlur: onBlur, onFocus: onFocus, onChange: this.onChangeMapper, allowSpaceInQuery: true, onKeyDown: onKeyDown, style: { suggestions: { marginTop: "28px" } } },
            react_1.default.createElement(react_mentions_1.Mention, { className: "add-comment-mention", onAdd: onAddMentionComplete, trigger: MentionRegex_1.mentionRegex, data: (0, MentionUtilities_1.mentionSuggestionFilter)(pagePermissionsStore), renderSuggestion: this.renderSuggestion(this.errorMessage), displayTransform: displayTransform, markup: markupFormatWithTokens })));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], AddCommentInput.prototype, "errorMessage", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AddCommentInput.prototype, "setErrorMessage", void 0);
    AddCommentInput = __decorate([
        mobx_react_1.observer
    ], AddCommentInput);
    return AddCommentInput;
}(react_1.default.Component));
var displayTransform = function (_id, display) { return "@".concat(display); };
exports.default = AddCommentInput;
